import { useEffect, useState } from "react";
import { IdentificationBadge } from "@phosphor-icons/react";
import { SettingsCrud } from "./SettingsCrud";
import api from "../../lib/api";

/** Positions section — reuses the existing /positions API. Department is chosen
 *  from managed Departments (Settings Engine). */
export function PositionsSettings() {
  const [depts, setDepts] = useState([]);
  useEffect(() => {
    api.get("/departments").then(({ data }) =>
      setDepts((data || []).filter((d) => d.active !== false).map((d) => ({ value: d.name, label: d.name })))
    ).catch(() => {});
  }, []);

  return (
    <SettingsCrud
      testid="positions"
      title="Positions"
      icon={IdentificationBadge}
      showInactive
      description="Job roles employees occupy. Positions are referenced by KPI templates and employee records."
      endpoint="/positions"
      subtitle={(p) => [p.department, p.supervisor_role].filter(Boolean).join(" · ")}
      body={(p) => p.job_description}
      meta={(p) => `${p.employee_count ?? 0} employee${p.employee_count === 1 ? "" : "s"}`}
      emptyText="No positions yet. Add the roles your staff occupy — positions are referenced by KPI templates and employee records."
      fields={[
        { name: "name", label: "Position title", type: "text", required: true, placeholder: "e.g. Sales Representative" },
        { name: "department", label: "Department", type: "select", options: depts, placeholder: "Select department" },
        { name: "job_description", label: "Job description", type: "textarea", rows: 3, placeholder: "Short summary of responsibilities" },
        { name: "supervisor_role", label: "Reports to (role/title)", type: "text", placeholder: "e.g. Sales Manager" },
      ]}
    />
  );
}

export default PositionsSettings;
